import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ScheduledEventFilterBookingCapacity, ScheduledEventFilters } from '../../../../../../../../models/scheduled-event';
import { EventType, EventTypeCategory} from '../../../../../../../../models/event-type';
import { LocationService } from '../../../../../../../../services/location/location.service';
import { AccountService } from '../../../../../../../../services/account/account.service';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { propExists, searchList } from '../../../../../../../../utils';
import { SelectStaffUserModalComponent } from '../../../../../modals/select-staff-user-modal/select-staff-user-modal.component';
import { User } from '../../../../../../../../models/user';
import { EventTypeStatus } from '../../../../../../../../models/event-type-enums';


@Component({
  selector: 'app-scheduled-events-filters-modal',
  templateUrl: './scheduled-events-filters-modal.component.html',
  styleUrls: ['./scheduled-events-filters-modal.component.css']
})
export class ScheduledEventsFiltersModalComponent implements OnInit {
  @Input() inputFilters: ScheduledEventFilters;
  @Input() eventTypes: EventType[];
  @Input() eventCategories: EventTypeCategory[];
  @Input() fullBookingCapacityCalculation: boolean;
  @Input() savedCallback: (newFilters: ScheduledEventFilters) => undefined;

  public filters: ScheduledEventFilters;
  public hasSpecificInstructorSelected = false;
  public eventTypeSearchInput = '';

  public mustSelectInstructorError = false;

  public ScheduledEventFilterBookingCapacity = ScheduledEventFilterBookingCapacity;
  public EventTypeStatus = EventTypeStatus;

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
    public locationService: LocationService,
    public accountService: AccountService
  ) {}

  ngOnInit() {
    // Get a deep copy of the input filters. This ensures that the filters are
    // only updated once they are submitted, rather than as the user edits them.
    this.filters = {};

    for (const key of Object.keys(this.inputFilters)) {
      this.filters[key] = this.inputFilters[key];
    }

    if (propExists(this.filters.instructor_id)) {
      this.hasSpecificInstructorSelected = true;
    }
  }

  public handleSubmit() {
    this.mustSelectInstructorError = false;

    if (this.hasSpecificInstructorSelected && !propExists(this.filters.instructor_id)) {
      this.mustSelectInstructorError = true;
      return;
    }

    this.savedCallback(this.filters);
    this.activeModal.close();
  }

  public handleClearAll() {
    // Reset all filters to their default state.
    this.filters = {
      location_id: this.accountService.getMyAccount().default_gym_id
    };
  }

  public getSelectedEventType(): EventType {
    for (const eventType of this.eventTypes) {
      if (eventType.id === this.filters.event_type_id) {
        return eventType;
      }
    }

    return null;
  }

  public handleEventTypeTypeahead: OperatorFunction<string, readonly EventType[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.searchEventTypes(term).slice(0, 10))
    )

  public eventTypeTypeaheadFormatter(eventType: EventType) {
    if (eventType.status === EventTypeStatus.retired) {
      return eventType.name + ' (Retired)';
    } else {
      return eventType.name;
    }
  }

  public openSelectInstructorModal() {
    const modalRef = this.modalService.open(SelectStaffUserModalComponent);
    modalRef.componentInstance.excludeUserIds = [];
    modalRef.componentInstance.submitCallback = (result: User) => {
      this.filters.instructor_id = result.id;
      this.filters.instructor_name = result.first_name + ' ' + result.last_name;
    }
  }

  private searchEventTypes(term: string): EventType[] {
    return searchList<EventType>(
      term,
      this.eventTypes.map((eventType) => {
        return {
          value: eventType,
          searchableText: eventType.name
        };
      })
    );
  }
}
